<template>
    <header>
        <p class="back-web">
            <a href="https://viccarbe.com/">&#60; {{ $t('back-to-viccarbe-website') }}</a>
        </p>
        <div class="menu">
            <RouterLink to="/">
                <img src="@/assets/logo.svg" alt="" />
            </RouterLink>
            <NavItems/>
        </div>
    </header>
</template>

<script setup>
import NavItems from './NavItems.vue';


</script>

<style scoped lang="scss">
header{
    border-bottom: 1px solid $mid-grey-color;
    font-family: "Feijoa Medium";
    font-size: 13px;
    line-height: 22px;
    padding-top: 20px;
    box-sizing: border-box;

    & a{
        text-decoration: none;
        color: $dark-grey-color;
    }
    & *{
        box-sizing: border-box;
    }

    & img{
        display: inline-flex;
        align-self: center;
        width: 200px;
    }
    & > .menu{
        display: flex;
        align-items: center;
        margin-top: 1rem;
        height: 3.75rem;
    }
    & > .back-web{
        text-align: right;
        margin: 0;
        & a{
            color: $light-grey-color;
            &::first-letter{
                font-size: 16px;
            }
        }
    }
}


@include for-phone-only(){
    header{
        border: 0;
        & > .menu {
            justify-content: center;
            & > ul{
                display: none;
            }
        }
        & > .back-web{
            display: none;
        }

    }
}
@include for-phone-only(){
    header{
        display: flex;
        margin-top: 0;
        justify-content: center;
        align-items: center;
        height: 100px;
    }
    .menu{
        display: flex;
        & a{
            width: 65%;
        }
        & img {
            display: block;
            width: 100%;
        }
    }
}


</style>
